export default "/backend/static/media/modify_organization1.5f5bcf41.png";